import { render, staticRenderFns } from "./VipBadge.vue?vue&type=template&id=2b9ba2a4&scoped=true"
import script from "./VipBadge.vue?vue&type=script&lang=ts"
export * from "./VipBadge.vue?vue&type=script&lang=ts"
import style0 from "./VipBadge.vue?vue&type=style&index=0&id=2b9ba2a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9ba2a4",
  null
  
)

export default component.exports